// vim: ft=javascriptreact
import { useEffect, useContext } from 'react'
import { Auth, Hub } from 'aws-amplify'
import { ImperialBookingContext } from './context/ImperialBookingContext'
import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from './hooks/useAuth'

const AuthChecker = () => {
  const {
    setAuthCheckComplete,
    setCognitoUser,
    originalPathname,
    setOriginalPathname,
    resetContext,
  } = useContext(ImperialBookingContext)
  const {
    isSignedIn,
    setAuthError,
  } = useAuth()

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    Hub.listen('custom', (data) => {
      const { payload } = data
      const { event, message } = payload
      console.log('Just got an AuthChecker event.', event)
      switch (event) {
        case 'signIn_failure':
          if (/The OAuth response flow failed/.test(message)) {
            setAuthError("A Facebook error occurred, and we couldn't retrieve your information.")
          } else if (/failed to signin/.test(message)) {
            // do nothing
          } else {
            setAuthError(message)
          }
          break

        case 'expiredAuth':
          navigate('/')
          resetContext()
          Auth.signOut()
          setAuthError('Your session has expired. Please sign in again.')
      }
    })

    Auth.currentAuthenticatedUser()
      .then((user) => {
        if (!!process.env.REACT_APP_DEBUG) {
          console.log('Authenticated as ', user)
        }
        setCognitoUser(user)
        if (/^\/auth/.test(location.pathname)) { 
          if (originalPathname) {
            navigate(originalPathname)
          } else {
            navigate('/')
          }
        }
      })
      .catch((err) => {
        if (process.env.REACT_APP_DEBUG) {
          console.log('Auth.currentAuthenticatedUser()', err)
        }
        if (!/^\/auth/.test(location.pathname)) { 
          console.log('Remembering', location.pathname)
          setOriginalPathname(location.pathname)
          navigate('/auth/sign-in')
        }
      })
      .finally(() => {
        setTimeout(() => {
          setAuthCheckComplete(true)
        }, 1000)
      })
  }, [])

  useEffect(() => {
    if (isSignedIn && originalPathname) {
      navigate(originalPathname)
    }
  }, [isSignedIn, originalPathname])

  return null
}

export default AuthChecker
